import moment from 'moment-timezone'
import 'moment/locale/es'

moment.locale('es')

export default moment
